import React, {FC} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMinus} from '@fortawesome/free-solid-svg-icons';
import {Button} from '@deviceinsight/ng-ui-basic-components';

type Props = {
	onClick: (...args: Array<any>) => any;
};

const DeleteButton: FC<Props> = ({onClick, ...htmlAttributes}: Props) => {
	return (
		<Button naked onClick={onClick} {...htmlAttributes}>
			<FontAwesomeIcon color="#002e48" icon={faMinus} size={'lg'} />
		</Button>
	);
};

export default DeleteButton;
